import { Route, Routes } from 'react-router-dom';
import { ApplicationPage } from './pages/ApplicationPage';
import { DataConnectionPage } from './pages/DataConnectionPage';
import { ShippingInfoPage } from './pages/ShippingInfoPage';
import { ShippingOptionsPage } from './pages/ShippingOptionsPage';
import { ConsentPage } from './pages/ConsentPage';
import { ConsentProtector } from './pages/ConsentProtector';
import { ApplicationProvider } from './context/useApplication';

export const ApplicationForm = ({
    onComplete,
    env,
    leadData,
    consumeLeadData,
    enableConsentCheck = true,
}) => {
    return (
        <ApplicationProvider env={env} leadData={leadData} consumeLeadData={consumeLeadData}>
            <Routes path="*">
                <Route path="consent" element={<ConsentPage />} />
                <Route
                    path="application"
                    element={
                        <ConsentProtector enableConsentCheck={enableConsentCheck}>
                            <ApplicationPage onComplete={onComplete} />
                        </ConsentProtector>
                    }
                />
                <Route path="shipping-info" element={<ShippingInfoPage />} />
                <Route path="shipping-info/:bill_id" element={<ShippingInfoPage />} />
                <Route path="shipping-methods/:bill_id" element={<ShippingOptionsPage />} />
                <Route
                    path="data-connection/:company_id"
                    element={<DataConnectionPage onComplete={onComplete} env={env} />}
                />
            </Routes>
        </ApplicationProvider>
    );
};
